module.exports = __webpack_public_path__ + "img/banner04.ecabef8f.jpg";